export class ActionButton {
  buttonType: ButtonType;
  buttonClass: string;
  text: string;

  showLoading?: boolean;
  icon?: string;
  disabled?: boolean;
  callback?: any;
  routerLink?: string;
  queryParams?: object;
  keepText?: boolean;

  constructor(init?: Partial<ActionButton>) {
    Object.assign(this, init);
  }
}

export enum ButtonType {
  Loading = 'loading',
  Default = 'default',
}
